import React, { useMemo } from 'react'
import {
  Link,
  ValidationContainer,
  ValidationMessage,
  ValidationIconCircle,
  ValidationMessageContainer,
  ValidationNoticeWrapper,
  ValidationNotice,
  ValidationNoticeTexts,
  ValidationFailWrapper,
  ValidationFailText,
} from './ValidateTag.styled'
import {
  Button,
  theme,
  useFrontEndEventTrackingService,
} from '@clickcease/cc-client-components-lib'
import { CheckIcon } from 'Assets/icons/CheckIcon'
import { RoatatingBars } from 'Assets/animated/RotatingBars'
import { useGetTagValidation } from '../api/getTagValidation'
import { XButton } from 'Assets/icons/XButton'
import { useTranslation, Trans } from 'react-i18next'
import { useZendeskChat } from 'src/hooks/zendesk/useZendeskChat'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleExclamation } from '@fortawesome/pro-light-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

export const ValidateTag = ({
  domainId,
  handleTagValidation,
}: {
  domainId: number
  handleTagValidation?: () => void
}) => {
  const { t } = useTranslation('domainManagement')
  const { openChat } = useZendeskChat()
  const { refetch, isFetching, data } = useGetTagValidation({ domainId })
  const { track } = useFrontEndEventTrackingService()

  const validate = async () => {
    await refetch()
    track(['segment'], `Validate tag`, {})
  }

  const validationStatus = useMemo(() => {
    if (data && !(data instanceof Error) && data.data) {
      const isProtected = data.data.protected
      if (isProtected) {
        handleTagValidation?.()
      }
      return isProtected
    }
    return false
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const validationMessage = () => {
    if (isFetching) {
      return t('get_tag_modal.validation_lodaing')
    } else if (validationStatus) {
      return t('get_tag_modal.validation_success')
    } else {
      return (
        <ValidationFailWrapper>
          <ValidationFailText>
            <Trans ns="domainManagement" i18nKey="validation_fail_1">
              Tracking tag was not detected. It can take up to 5 minutes for the validation to be
              completed.
            </Trans>
          </ValidationFailText>
          <ValidationFailText>
            <Trans ns="domainManagement" i18nKey="validation_fail_2">
              Please try again later or <Link onClick={() => openChat()}>contact support</Link> for
              more help.
            </Trans>
          </ValidationFailText>
        </ValidationFailWrapper>
      )
    }
  }

  return (
    <ValidationContainer>
      <Button text={t('get_tag_modal.validate_tag')} variant={'outline'} onClick={validate} />
      {!data && (
        <ValidationNoticeWrapper>
          <FontAwesomeIcon
            icon={faCircleExclamation as IconProp}
            style={{ color: theme.colors.neutral.value, marginTop: '3px' }}
          />
          <ValidationNoticeTexts>
            <ValidationNotice>{t('get_tag_modal.validation_notice_1')}</ValidationNotice>
            <ValidationNotice>{t('get_tag_modal.validation_notice_2')}</ValidationNotice>
          </ValidationNoticeTexts>
        </ValidationNoticeWrapper>
      )}

      {data && (
        <ValidationMessageContainer success={isFetching ? 'loading' : validationStatus}>
          {isFetching ? (
            <RoatatingBars />
          ) : (
            <ValidationIconCircle>
              {validationStatus ? (
                <CheckIcon width={'10px'} height={'10px'} />
              ) : (
                <XButton width={'10px'} height={'10px'} />
              )}
            </ValidationIconCircle>
          )}
          <ValidationMessage>{validationMessage()}</ValidationMessage>
        </ValidationMessageContainer>
      )}
    </ValidationContainer>
  )
}
